import { User, UserBackendResponse } from '@/types/user.types';

/**
 * Transform backend user response (snake_case) to frontend user object (camelCase)
 */
export const transformUserFromBackend = (backendUser: UserBackendResponse): User => {
  return {
    id: backendUser.id,
    email: backendUser.email,
    firstName: backendUser.first_name,
    lastName: backendUser.last_name,
    role: backendUser.role,
    phoneNumber: backendUser.phone,
    profileImage: backendUser.profile_image,
    // The backend exposes a single is_verified flag. We surface it both as
    // isEmailVerified (legacy usages) and isVerified (account/farmer
    // verification, used by the dashboard verification nudge).
    isEmailVerified: backendUser.is_verified,
    isVerified: backendUser.is_verified,
    isActive: backendUser.is_active,
    createdAt: backendUser.created_at,
    updatedAt: backendUser.updated_at,
  };
};

/**
 * Transform frontend user object (camelCase) to backend format (snake_case)
 */
export const transformUserToBackend = (user: Partial<User>): Partial<UserBackendResponse> => {
  return {
    ...(user.email && { email: user.email }),
    ...(user.firstName && { first_name: user.firstName }),
    ...(user.lastName && { last_name: user.lastName }),
    ...(user.role && { role: user.role }),
    ...(user.phoneNumber && { phone: user.phoneNumber }),
    ...(user.profileImage && { profile_image: user.profileImage }),
  };
};
